import { Injectable } from '@angular/core';
import { NedermanCompanyOrderBy, NedermanCompanyQueryInput } from 'app/backend/api';


@Injectable()
export class NedermanCompanyParams {

  public orderBy: NedermanCompanyOrderBy = NedermanCompanyOrderBy.Name;
  public searchValue = '';

  public query: NedermanCompanyQueryInput = {
    search: '',
    orderBy: NedermanCompanyOrderBy.Name
  };
}
